import { forwardRef, useCallback, useMemo } from 'react';
import YesNoMaybeComponent from 'components/Inputs/YesNoMaybe';

const YesNoMaybe = forwardRef(
  ({ field, onChange, isGetFullOptionObject, ...others }, ref) => {
    const options = useMemo(() => {
      return field.options.map((opt) => ({
        value: opt.id,
        label: opt.name,
      }));
    }, [field]);

    const handleChange = useCallback(
      (opt) => {
        if (isGetFullOptionObject) {
          onChange(opt || null);
        } else {
          onChange(opt ? opt.value : null);
        }
      },
      [onChange, isGetFullOptionObject]
    );

    return (
      <YesNoMaybeComponent
        ref={ref}
        options={options}
        onChange={handleChange}
        {...others}
      />
    );
  }
);

YesNoMaybe.displayName = 'YesNoMaybe';
export default YesNoMaybe;
